import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseTmaisPermissionsOperationKlassesProps<T> = {
  filters?: {
    search?: string
    withoutPermission?: boolean
  }
  mapper?: (data: any) => T,
}

export const useTmaisPermissionsOperationKlasses = <T,>({
  filters: { search = '', withoutPermission } = {},
  mapper = Mapper.default<T>(),
}: UseTmaisPermissionsOperationKlassesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisPermissionsOperationKlasses', search, withoutPermission],
    queryFn: () => {
      return privateAxios.get(`/tmais/permissions/operation_klasses`, {
        params: {
          search,
          'q[without_permission]': withoutPermission
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
